// Import model
import { SectionLineCondition } from '../models/SectionLineCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { SectionLineIndexedFields } from '../models/SectionLineIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { SectionLineIndexedFieldsSerializer } from './SectionLineIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SectionLineCondition - handles JSON serialization and deserialization with type validation
 */
export class SectionLineConditionSerializer {
  /**
   * Deserializes a JSON string into a SectionLineCondition instance
   */
  static deserialize(json: string): SectionLineCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SectionLineCondition instance
   */
  static fromObject(obj: any): SectionLineCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SectionLineCondition');
    }


    const instance: SectionLineCondition = {
      fieldName: obj['fieldName'] as SectionLineIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SectionLineCondition instances
   */
  static deserializeArray(json: string): SectionLineCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SectionLineCondition instance to a JSON string
   */
  static serialize(instance: SectionLineCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SectionLineCondition instance to a plain object
   */
  static toObject(instance: SectionLineCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of SectionLineCondition instances to a JSON string
   */
  static serializeArray(instances: SectionLineCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
